export const locale___ComPoiComponent = {
	'is_open': {
		de_de: 'Es ist jetzt geöffnet!',
		en_us: 'It\'s open now!',
		es_es: '¡Ya está abierto!',
		fr_fr: 'C\'est ouvert maintenant!',
		it_it: 'Adesso è aperto!',
	},
	'is_closed': {
		de_de: 'Es ist jetzt geschlossen',
		en_us: 'It\'s closed now',
		es_es: 'Esta cerrado ahora',
		fr_fr: 'C\'est fermé maintenant',
		it_it: 'Adesso è chiuso',
	},
};